/*
@license
  Gem by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://help.archetypethemes.co/en/articles/206656

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
	console.log(
		"Gem theme (" +
			theme.settings.themeVersion +
			") by ARCHΞTYPE | Learn more at https://archetypethemes.co",
	);
}

(() => {
	if (
		window.Shopify &&
		window.Shopify.theme &&
		navigator &&
		navigator.sendBeacon &&
		window.Shopify.designMode
	) {
		navigator.sendBeacon(
			"https://api.archetypethemes.co/api/beacon",
			new URLSearchParams({
				shop: window.Shopify.shop,
				themeName:
					window.theme &&
					window.theme.settings &&
					`${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
				role: window.Shopify.theme.role,
				route: window.location.pathname,
				themeId: window.Shopify.theme.id,
				themeStoreId: window.Shopify.theme.theme_store_id || 0,
				isThemeEditor: !!window.Shopify.designMode,
			}),
		);
	}

	theme.customerTemplates = () => {
		checkUrlHash();
		initEventListeners();
		resetPasswordSuccess();
		customerAddressForm();

		function checkUrlHash() {
			var hash = window.location.hash;

			// Allow deep linking to recover password form
			if (hash === "#recover") {
				toggleRecoverPasswordForm();
			}
		}

		function toggleRecoverPasswordForm() {
			var passwordForm = document
				.getElementById("RecoverPasswordForm")
				.classList.toggle("hide");
			var loginForm = document
				.getElementById("CustomerLoginForm")
				.classList.toggle("hide");
		}

		function initEventListeners() {
			// Show reset password form
			var recoverForm = document.getElementById("RecoverPassword");
			if (recoverForm) {
				recoverForm.addEventListener("click", (evt) => {
					evt.preventDefault();
					toggleRecoverPasswordForm();
				});
			}

			// Hide reset password form
			var hideRecoverPassword = document.getElementById(
				"HideRecoverPasswordLink",
			);
			if (hideRecoverPassword) {
				hideRecoverPassword.addEventListener("click", (evt) => {
					evt.preventDefault();
					toggleRecoverPasswordForm();
				});
			}
		}

		function resetPasswordSuccess() {
			var formState = document.querySelector(".reset-password-success");

			// check if reset password form was successfully submitted
			if (!formState) {
				return;
			}

			// show success message
			document.getElementById("ResetSuccess").classList.remove("hide");
		}

		function customerAddressForm() {
			var newAddressForm = document.getElementById("AddressNewForm");
			var addressForms = document.querySelectorAll(".js-address-form");

			if (!newAddressForm || !addressForms.length) {
				return;
			}

			// Country/province selector can take a short time to load
			setTimeout(() => {
				document.querySelectorAll(".js-address-country").forEach((el) => {
					var countryId = el.dataset.countryId;
					var provinceId = el.dataset.provinceId;
					var provinceContainerId = el.dataset.provinceContainerId;

					new Shopify.CountryProvinceSelector(countryId, provinceId, {
						hideElement: provinceContainerId,
					});
				});
			}, 1000);

			// Toggle new/edit address forms
			document.querySelectorAll(".address-new-toggle").forEach((el) => {
				el.addEventListener("click", () => {
					newAddressForm.classList.toggle("hide");
				});
			});

			document.querySelectorAll(".address-edit-toggle").forEach((el) => {
				el.addEventListener("click", (evt) => {
					var formId = evt.currentTarget.dataset.formId;
					document
						.getElementById("EditAddress_" + formId)
						.classList.toggle("hide");
				});
			});

			document.querySelectorAll(".address-delete").forEach((el) => {
				el.addEventListener("click", (evt) => {
					var formId = evt.currentTarget.dataset.formId;
					var confirmMessage = evt.currentTarget.dataset.confirmMessage;

					if (
						confirm(
							confirmMessage || "Are you sure you wish to delete this address?",
						)
					) {
						if (Shopify) {
							Shopify.postLink("/account/addresses/" + formId, {
								parameters: { _method: "delete" },
							});
						}
					}
				});
			});
		}
	};

	/*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

	/*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
	function DOMready(callback) {
		if (document.readyState != "loading") callback();
		else document.addEventListener("DOMContentLoaded", callback);
	}

	DOMready(() => {
		if (theme.settings.isCustomerTemplate) {
			theme.customerTemplates();
		}

		document.dispatchEvent(new CustomEvent("page:loaded"));

		// square footage calculator
		const squareFootageCalculator = document.querySelector(
			".product__square_footage_calculator",
		);
		const productQuantityInput = document.querySelector(
			".product__quantity input",
		);

		if (squareFootageCalculator) {
			const button = squareFootageCalculator.querySelector("button");
			button.addEventListener("click", () => {
				squareFootageCalculator.classList.toggle("is-open");
			});

			let calculatedValue = "";

			const lengthCalc = document.getElementById("square_footage_length");
			const widthCalc = document.getElementById("square_footage_width");
			const numBoxCalc = document.getElementById("number_of_boxes");

			lengthCalc.addEventListener("change", (e) => {
				if (e.currentTarget.value === "" || widthCalc.value === "") {
					calculatedValue = "";
				} else {
					calculatedValue = e.currentTarget.value * widthCalc.value;
				}

				numBoxCalc.value = calculatedValue;
				const event = new Event("change");
				numBoxCalc.dispatchEvent(event);
			});

			widthCalc.addEventListener("change", (e) => {
				if (e.currentTarget.value === "" || lengthCalc.value === "") {
					calculatedValue = "";
				} else {
					calculatedValue = e.currentTarget.value * lengthCalc.value;
				}

				numBoxCalc.value = calculatedValue;
				const event = new Event("change");
				numBoxCalc.dispatchEvent(event);
			});

			numBoxCalc.addEventListener("change", (e) => {
				const quantity = Math.ceil(
					e.currentTarget.value /
						Number(squareFootageCalculator.dataset.perBox),
				);
				document.getElementById("numboxes").innerText = Math.max(
					1,
					quantity,
				).toString();
				productQuantityInput.value = quantity;
				const event = new Event("change");
				productQuantityInput.dispatchEvent(event);
			});
		}

		// carpet calculator
		const carpetCalculator = document.querySelector(
			".product__carpet_calculator",
		);

		if (carpetCalculator) {
			const button = carpetCalculator.querySelector("button");
			button.addEventListener("click", () => {
				carpetCalculator.classList.toggle("is-open");
			});

			const carpetDesiredSqftCalc = document.getElementById(
				"carpet_desired_sqft",
			);
			const numBoxCalc = document.getElementById("number_of_boxes");
			const carpetResult = document.getElementById("carpet_result");
			const carpetWidthRaw = carpetCalculator.dataset.carpetWidth;

			// Find the actual quantity input - try multiple selectors
			let productQuantityInput = document.querySelector(
				".product__quantity input[name='quantity']",
			);
			if (!productQuantityInput) {
				productQuantityInput = document.querySelector(
					".js-qty__num[name='quantity']",
				);
			}
			if (!productQuantityInput) {
				productQuantityInput = document.querySelector("input[name='quantity']");
			}

						console.log("Found productQuantityInput:", productQuantityInput);
			console.log("Current quantity value:", productQuantityInput?.value);

			// Extract numeric value from the carpet width (in case it has text like "12 ft" or just "12")
			const carpetWidthMatch = carpetWidthRaw.match(/(\d+(?:\.\d+)?)/);
			const carpetWidth = carpetWidthMatch ? Number(carpetWidthMatch[1]) : 12; // Default to 12 if no match

			// Debug: Add form submission listener to see what quantity is being submitted
			const productForm = document.querySelector('form[action*="cart/add"]');
			if (productForm) {
				productForm.addEventListener("submit", (e) => {
					const formData = new FormData(productForm);
					console.log("Form being submitted with data:");
					for (const [key, value] of formData.entries()) {
						console.log(key + ": " + value);
					}
				});
			}

			// For carpet products, trigger initial calculation to set proper subtotal
			if (productQuantityInput && carpetWidth > 1) {
				// Set initial quantity to carpet width (minimum orderable)
				productQuantityInput.value = carpetWidth;
				
				// Debug: Add listener to detect when subtotal gets changed
				const subTotal = document.querySelector(".product__calculator__subtotal");
				if (subTotal) {
					const observer = new MutationObserver((mutations) => {
						mutations.forEach((mutation) => {
							if (mutation.type === 'childList' || mutation.type === 'characterData') {
								console.log("PDP Subtotal changed externally:", mutation.target.textContent);
								console.log("Current PDP quantity:", productQuantityInput.value);
							}
						});
					});
					observer.observe(subTotal, { childList: true, subtree: true, characterData: true });
				}
				
				// Try multiple approaches to trigger the subtotal update
				setTimeout(() => {
					// Method 1: Try to trigger quantity selector's _change method directly
					const quantitySelector =
						productQuantityInput.closest("quantity-selector");
					if (quantitySelector && quantitySelector._change) {
						console.log(
							"Triggering quantity selector _change with:",
							carpetWidth,
						);
						quantitySelector._change(carpetWidth);
					} else {
						// Method 2: Manually update subtotal
						const subTotal = document.querySelector(
							".product__calculator__subtotal",
						);
						if (subTotal && subTotal.dataset.price) {
							const price = Number.parseFloat(subTotal.dataset.price);
							const total = (carpetWidth * price).toFixed(2);
							console.log("Manual subtotal update:", {
								carpetWidth,
								price,
								total,
							});
							subTotal.querySelector(".the_subtotal span").innerHTML = total;
						}
					}

					// Method 3: Trigger change event
					const changeEvent = new Event("change", { bubbles: true });
					productQuantityInput.dispatchEvent(changeEvent);
				}, 100);
			}

			const calculateCarpetNeeded = (desiredSqft) => {
				if (
					!desiredSqft ||
					desiredSqft <= 0 ||
					!carpetWidth ||
					carpetWidth <= 0
				) {
					return { actualSqft: 0, lengthNeeded: 0 };
				}

				// Calculate length needed: desired sqft ÷ carpet width
				const lengthNeeded = desiredSqft / carpetWidth;

				// Round length up to nearest whole foot
				const roundedLength = Math.ceil(lengthNeeded);

				// Calculate actual square footage to buy: rounded length × carpet width
				const actualSqft = roundedLength * carpetWidth;

				return { actualSqft, lengthNeeded: roundedLength };
			};

			carpetDesiredSqftCalc.addEventListener("input", (e) => {
				const desiredSqft = Number(e.currentTarget.value);

				if (desiredSqft > 0) {
					const result = calculateCarpetNeeded(desiredSqft);

					// Update the square footage input
					numBoxCalc.value = result.actualSqft;
					const event = new Event("change");
					numBoxCalc.dispatchEvent(event);

					// Show calculation explanation with clearer messaging
					carpetResult.innerHTML = `
						<div style="margin-bottom: 5px;">Your requested area: <strong>${desiredSqft} sq. ft.</strong></div>
						<div style="margin-bottom: 5px;">Minimum orderable cut: ${result.lengthNeeded} ft length × ${carpetWidth} ft width = <strong>${result.actualSqft} sq. ft.</strong></div>
						<div>You will be charged for <strong>${result.actualSqft} sq. ft.</strong></div>
					`;
					carpetResult.style.display = "block";
				} else {
					numBoxCalc.value = "";
					carpetResult.style.display = "none";
					const event = new Event("change");
					numBoxCalc.dispatchEvent(event);
				}
			});

			numBoxCalc.addEventListener("change", (e) => {
				// For carpet, the quantity is the square footage needed
				const quantity = Math.max(1, Math.ceil(Number(e.currentTarget.value)));
				document.getElementById("numboxes").innerText = quantity.toString();

				// Update the actual quantity input (with safety check)
				if (productQuantityInput) {
					productQuantityInput.value = quantity;
					console.log(
						"Updated quantity input to:",
						quantity,
						"Input value now:",
						productQuantityInput.value,
					);
					console.log("Input element:", productQuantityInput);
					console.log("Input name attribute:", productQuantityInput.name);
					console.log("Input form attribute:", productQuantityInput.form);
				} else {
					console.log(
						"productQuantityInput not found, skipping quantity update",
					);
				}

				// Trigger the quantity selector's change method directly
				const quantitySelector = productQuantityInput
					? productQuantityInput.closest("quantity-selector")
					: null;
				console.log("quantitySelector found:", quantitySelector);
				console.log(
					"quantitySelector._change method:",
					quantitySelector?._change,
				);

				if (quantitySelector && quantitySelector._change) {
					console.log(
						"Calling quantitySelector._change with quantity:",
						quantity,
					);
					quantitySelector._change(quantity);
				} else {
					// Fallback: manually update subtotal for carpet
					const subTotal = document.querySelector(
						".product__calculator__subtotal",
					);
					if (subTotal && subTotal.dataset.price) {
						const price = Number.parseFloat(subTotal.dataset.price);
						const total = (quantity * price).toFixed(2);
						console.log("Carpet calculation fallback:", {
							quantity,
							price,
							total,
						});
						subTotal.querySelector(".the_subtotal span").innerHTML = total;
					} else {
						console.log("Subtotal element or price data missing:", {
							subTotal,
							price: subTotal?.dataset.price,
						});
					}
				}

				// Also trigger the input change event to make sure quantity selector picks it up
				if (productQuantityInput) {
					console.log("Triggering input change event");
					const changeEvent = new Event("change", { bubbles: true });
					productQuantityInput.dispatchEvent(changeEvent);

					// Also try triggering input event
					const inputEvent = new Event("input", { bubbles: true });
					productQuantityInput.dispatchEvent(inputEvent);

					// Force update the quantity selector if it exists
					const qtySelector = productQuantityInput.closest(".js-qty__wrapper");
					if (qtySelector) {
						console.log("Found .js-qty__wrapper, trying to update it");
						// Manually trigger the quantity selector's internal update
						const plusBtn = qtySelector.querySelector(".js-qty__adjust--plus");
						const minusBtn = qtySelector.querySelector(
							".js-qty__adjust--minus",
						);
						console.log("Plus button:", plusBtn, "Minus button:", minusBtn);
					}
				}
			});
		}

		// policy page
		const policyPage = document.querySelector(".policy_page");
		if (policyPage) {
			const sections = policyPage.querySelectorAll(
				".policy_page_sidebar ul li",
			);
			const singles = policyPage.querySelectorAll(".policy_page_body_single");
			console.log(sections, singles);
			sections.forEach((section) => {
				section.addEventListener("click", (e) => {
					const target = e.currentTarget;
					if (target.classList.contains("is-active")) return;
					const id = target.dataset.id;

					sections.forEach((el) => el.classList.remove("is-active"));
					target.classList.add("is-active");

					singles.forEach((el) => {
						if (el.dataset.id === id) {
							el.classList.add("is-active");
						} else {
							el.classList.remove("is-active");
						}
					});
				});
			});
		}

		// sampler orderer
		async function findSampleVariantBySku(sku) {
			const skuQuery = `variants.sku:${sku}`;
			const searchUrl = `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(skuQuery)}&resources[type]=product&resources[limit]=10`;

			try {
				const searchResponse = await fetch(searchUrl);
				const searchData = await searchResponse.json();
				const products = searchData?.resources?.results?.products || [];

				for (const product of products) {
					const productResponse = await fetch(`${window.Shopify.routes.root}products/${product.handle}.js`);
					if (!productResponse.ok) continue;
					const productData = await productResponse.json();
					const variant = productData.variants.find((v) => v.sku === sku);
					if (variant) return variant;
				}
			} catch (error) {
				console.error("[Sample] Error searching for sample product:", error);
			}
			return null;
		}

		document.addEventListener("click", async (e) => {
			const button = e.target.closest(".sampler-orderer");
			if (!button) return;

			e.preventDefault();
			e.stopPropagation();

			const productHandle = button.dataset.productHandle;
			const textSpan = button.querySelector("span");
			const originalText = textSpan ? textSpan.textContent : "Add Sample";

			if (button.disabled) return;
			button.disabled = true;
			if (textSpan) textSpan.textContent = "Adding...";

			const restore = (message, delay = 2000) => {
				if (textSpan && message) textSpan.textContent = message;
				setTimeout(() => {
					if (textSpan) textSpan.textContent = originalText;
					button.disabled = false;
				}, delay);
			};

			try {
				let currentSku = button.dataset.currentSku;

				// Fallback: fetch the product only if the SKU wasn't rendered server-side
				if (!currentSku) {
					const productResponse = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
					const productData = await productResponse.json();
					const firstVariant = productData.variants?.find((v) => v.available) || productData.variants?.[0];
					currentSku = firstVariant?.sku;
				}

				if (!currentSku) {
					console.error("[Sample] No SKU found for product:", productHandle);
					restore("Unavailable");
					return;
				}

				const sampleSku = currentSku + "-S";

				// Parallelize sample lookup + cart fetch
				const [sampleVariant, cart] = await Promise.all([
					findSampleVariantBySku(sampleSku),
					fetch(window.Shopify.routes.root + "cart.js").then((r) => r.json()),
				]);

				if (!sampleVariant) {
					console.error("[Sample] No sample product found for SKU:", sampleSku);
					restore("Unavailable");
					return;
				}

				const alreadyInCart = cart.items?.some((item) => item.variant_id == sampleVariant.id);

				if (alreadyInCart) {
					document.dispatchEvent(new CustomEvent("cart:build"));
					document.dispatchEvent(new CustomEvent("cart:open"));
					restore("Already in Cart");
					return;
				}

				const addResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ items: [{ id: sampleVariant.id, quantity: 1 }] }),
				});

				if (!addResponse.ok) {
					const errorData = await addResponse.json().catch(() => ({}));
					console.error("[Sample] Failed to add sample to cart:", errorData);
					restore("Error - Try Again");
					return;
				}

				document.dispatchEvent(new CustomEvent("cart:build"));
				document.dispatchEvent(new CustomEvent("cart:open"));
				restore("Added!");
			} catch (error) {
				console.error("[Sample] Error adding sample to cart:", error);
				restore("Error - Try Again");
			}
		});

		const consultationPopup = document.querySelector(".consultation_popup");
		if (consultationPopup) {
			consultationPopup
				.querySelector("button")
				.addEventListener("click", () => {
					consultationPopup.remove();
				});
			window.addEventListener("scroll", (e) => {
				if (window.scrollY >= window.innerHeight) {
					if (consultationPopup) consultationPopup.classList.add("is-visible");
				}
			});
		}

		const elms = document.getElementsByClassName("splide");

		// Center the arrows on the IMAGE (not the whole card). We measure how much
		// taller the slide is than its image (i.e. the title/link block below) and
		// expose half of it as --arrow-text-offset, which the CSS subtracts from 50%.
		function measureArrowOffset(el) {
			var slide = el.querySelector(".splide__slide");
			if (!slide) return;
			var imgWrap =
				slide.querySelector(
					".gallery__image-inner, .gallery__placeholder-image, .grid-product__image-mask, .grid-product__image-wrapper"
				) || slide.querySelector("img");
			if (!imgWrap) return;
			var slideH = slide.getBoundingClientRect().height;
			var imgH = imgWrap.getBoundingClientRect().height;
			var offset = slideH > imgH ? (slideH - imgH) / 2 : 0;
			el.style.setProperty("--arrow-text-offset", offset + "px");
		}

		function setupSplide(el, options) {
			var splide = new Splide(el, options);
			var recenter = function () {
				measureArrowOffset(el);
			};
			splide.on("mounted resized", recenter);
			splide.mount();
			recenter();
			window.addEventListener("resize", recenter);
			var img = el.querySelector(".splide__slide img");
			if (img) img.addEventListener("load", recenter);
		}

		for (var i = 0; i < elms.length; i++) {
			var showArrows = elms[i].getAttribute("data-arrows") === "true";
			if (elms[i].classList.contains("square")) {
				setupSplide(elms[i], {
					type: "loop",
					perPage: 3,
					pagination: false,
					arrows: showArrows,
					breakpoints: {
						768: {
							perPage: 2,
						},
					},
				});
			} else {
				setupSplide(elms[i], {
					type: "loop",
					perPage: 4,
					pagination: false,
					arrows: showArrows,
					breakpoints: {
						768: {
							perPage: 2,
						},
						1024: {
							perPage: 3,
						},
					},
				});
			}
		}
	});
})();
